import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirtable16 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1141_44031)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.7168 2.21393L1.76892 5.91668C1.27129 6.12293 1.27654 6.82943 1.77717 7.02781L10.7622 10.5911C11.5516 10.9042 12.4308 10.9042 13.2203 10.5911L22.2053 7.02781C22.7059 6.82906 22.7115 6.12256 22.2135 5.91668L13.266 2.21431C12.4497 1.87648 11.5327 1.87648 10.7164 2.21431",
				fill: "#FFCC00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.7886 12.5361V21.4375C12.7887 21.5353 12.8127 21.6316 12.8585 21.7179C12.9044 21.8043 12.9706 21.8782 13.0515 21.9331C13.1324 21.988 13.2254 22.0224 13.3226 22.0331C13.4198 22.0439 13.5181 22.0307 13.6091 21.9948L23.6216 18.1083C23.7332 18.0639 23.8289 17.9871 23.8963 17.8877C23.9638 17.7884 23.9999 17.6711 23.9999 17.551V8.65002C23.9998 8.55224 23.9758 8.45598 23.93 8.36961C23.8842 8.28323 23.8179 8.20937 23.7371 8.15443C23.6562 8.0995 23.5631 8.06516 23.4659 8.05442C23.3687 8.04367 23.2704 8.05684 23.1794 8.09277L13.1669 11.9793C13.0554 12.0236 12.9596 12.1004 12.8922 12.1998C12.8247 12.2991 12.7886 12.4161 12.7886 12.5361Z",
				fill: "#31C2F2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4514 12.9973L7.17836 14.578L0.905738 17.5836C0.508238 17.7756 0.000488281 17.4861 0.000488281 17.0436V8.68933C0.000488281 8.52958 0.0822383 8.39158 0.192488 8.28808C0.237554 8.24319 0.288673 8.20482 0.344363 8.17408C0.494363 8.08408 0.708113 8.06008 0.889988 8.13208L10.4019 11.9008C10.8894 12.0928 10.9269 12.7701 10.4517 12.9977",
				fill: "#ED3049"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4511 12.9981L7.47964 14.4328L0.191895 8.28808C0.23696 8.24319 0.288079 8.20482 0.34377 8.17408C0.49377 8.08408 0.707519 8.06008 0.889394 8.13208L10.4013 11.9008C10.8888 12.0928 10.9263 12.7705 10.4511 12.9981Z",
				fill: "#C62842"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1141_44031",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgAirtable16;
